import Vue from 'vue'
import Router from 'vue-router'

const files = require.context('./routers/', true, /\.js$/i)
const importedRoutes = []
files.keys().forEach(key => {
  for (const file in files(key)) {
    importedRoutes.push(files(key)[file])
  }
})

Vue.use(Router)

export default new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: importedRoutes
})
